import React from 'react';
import styled from 'styled-components';
import { FaComments } from 'react-icons/fa';

const ServicesSection = styled.section`
  padding: 4rem 5%;
  background-color: #f8f9fa;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 3rem;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
`;

const ServiceCard = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  text-align: center;
  transition: transform 0.3s ease;
  max-width: 900px;
  margin: 0 auto;

  &:hover {
    transform: translateY(-5px);
  }
`;

const ServiceIcon = styled.div`
  font-size: 3rem;
  color: #8B7D5B;
  margin-bottom: 1rem;
`;

const ServiceTitle = styled.h3`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
`;

const ServiceDescription = styled.p`
  color: #666;
  margin-bottom: 1.5rem;
`;

const LearnMoreLink = styled.a`
  display: inline-block;
  color: #8B7D5B;
  text-decoration: none;
  font-weight: bold;
  padding: 0.5rem 1rem;
  border: 2px solid #8B7D5B;
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover {
    background-color: #8B7D5B;
    color: white;
  }
`;

function FeaturedServices() {
  const services = [
    {
      name: 'Free Consultation Service',
      description: "Our skilled professionals offer personalised advice to help you achieve your beauty goals. During your consultation, we'll carefully assess your skin type and address your specific concerns. We'll discuss your aesthetic aspirations in detail and explain the most suitable treatment options. We'll create a customised beauty plan tailored to your unique needs, because we believe that every individual is unique and deserves a unique approach. This is your opportunity to ask questions and gain expert insights into our services. Our consultation is completely free and comes with no obligation - it's simply our way of providing you with the knowledge you need to make informed decisions about your beauty journey. Book your complimentary consultation today and take the first step towards enhancing your natural beauty.",
      icon: <FaComments />,
    },
  ];

  return (
    <ServicesSection>
      <SectionTitle>Our Featured Services</SectionTitle>
      <ServicesGrid>
        {services.map((service, index) => (
          <ServiceCard key={index}>
            <ServiceIcon>{service.icon}</ServiceIcon>
            <ServiceTitle>{service.name}</ServiceTitle>
            <ServiceDescription>{service.description}</ServiceDescription>
            <LearnMoreLink 
              href="https://facesconsent.com/clinics/london-la-beauty-306208" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Learn More
            </LearnMoreLink>
          </ServiceCard>
        ))}
      </ServicesGrid>
    </ServicesSection>
  );
}

export default FeaturedServices;